import { useEffect, useCallback, useRef } from "react";

export const useProyeccionUpdates = (proyeccionData, setTotalCuotasGlobal, setVinculaciones) => {
  const updateTimeoutRef = useRef(null);

  const actualizarTotalCuotas = useCallback(() => {
    if (proyeccionData?.proyeccion) {
      // Cancelar actualización anterior si existe
      if (updateTimeoutRef.current) {
        clearTimeout(updateTimeoutRef.current);
      }
      // Programar nueva actualización
      updateTimeoutRef.current = setTimeout(() => {
        const maxCuotaGlobal = Object.values(proyeccionData.proyeccion).reduce((max, data) => {
          return Math.max(max, data?.proyeccion?.length || 0);
        }, 0);
        setTotalCuotasGlobal(maxCuotaGlobal);
      }, 50); // Pequeño debounce para evitar actualizaciones múltiples
    }
  }, [proyeccionData, setTotalCuotasGlobal]);

  const actualizarVinculaciones = useCallback(() => {
    if (proyeccionData?.clases_vinculadas) {
      setVinculaciones(proyeccionData.clases_vinculadas);
    }
  }, [proyeccionData?.clases_vinculadas, setVinculaciones]);

  useEffect(() => {
    actualizarTotalCuotas();
    actualizarVinculaciones();

    return () => {
      if (updateTimeoutRef.current) {
        clearTimeout(updateTimeoutRef.current);
      }
    };
  }, [actualizarTotalCuotas, actualizarVinculaciones]);

  return {
    actualizarTotalCuotas,
    actualizarVinculaciones,
  };
};
